import React, { useState } from 'react';
import './PaymentPage.css';

const iyzicoLogoUrl = 'https://www.iyzico.com/assets/img/marka-kimligi/iyzico-white-bg.png';
const iyzicoSiteUrl = 'https://www.iyzico.com/';

const installmentPlans = [
  { count: 1, label: 'PESIN', total: 100.00 },
  { count: 2, label: '2 TAKSIT', total: 104.00 },
  { count: 3, label: '3 TAKSIT', total: 106.50 },
  { count: 4, label: '4 TAKSIT', total: 110.00 },
  { count: 5, label: '5 TAKSIT', total: 112.50 },
  { count: 6, label: '6 TAKSIT', total: 117.00 },
];

function formatTry(value) {
  return value.toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function formatCardNumber(value) {
  return value
    .replace(/\D/g, '')
    .slice(0, 16)
    .replace(/(.{4})/g, '$1 ')
    .trim();
}

function maskCvv(value) {
  return value ? value.replace(/./g, '*') : '***';
}

export function CreditCardCollectionPage() {
  const [approvalSent, setApprovalSent] = useState(false);
  const [selectedInstallment, setSelectedInstallment] = useState(1);
  const [cardInfo, setCardInfo] = useState({
    name: 'Hakan Bekar',
    number: '5743 0349 5345 4357',
    expiry: '05/24',
    cvv: '123',
  });
  const [isCvvFocused, setIsCvvFocused] = useState(false);
  const [openSections, setOpenSections] = useState({
    card: true,
    options: true,
    product: true,
  });
  const selectedPlan = installmentPlans.find(plan => plan.count === selectedInstallment) ?? installmentPlans[0];
  const installmentAmount = selectedPlan.total / selectedPlan.count;
  const totalText = `${formatTry(selectedPlan.total)} TL`;
  const installmentText = `${formatTry(installmentAmount)} TL`;
  const cardNumberLength = cardInfo.number.replace(/\s/g, '').length;
  const cardNumberClass = cardNumberLength > 12 ? ' compact' : '';

  const handleApproval = (event) => {
    event.preventDefault();
    setApprovalSent(true);
  };

  const toggleSection = (sectionName) => {
    setOpenSections(current => ({
      ...current,
      [sectionName]: !current[sectionName],
    }));
  };

  const updateCardInfo = (field, value) => {
    const nextValue = field === 'number' ? formatCardNumber(value) : value;
    setCardInfo(current => ({
      ...current,
      [field]: nextValue,
    }));
  };

  return (
    <div className="payment-page">
      <div className="payment-brand-row">
        <a className="payment-brand-link" href={iyzicoSiteUrl} target="_blank" rel="noreferrer">
          <img src={iyzicoLogoUrl} alt="iyzico" />
        </a>
        <a className="payment-brand-url" href={iyzicoSiteUrl} target="_blank" rel="noreferrer">
          iyzico.com
        </a>
      </div>

      <section className="payment-limit-panel" aria-labelledby="limit-request-title">
        <div>
          <h1 id="limit-request-title">Kredi Karti Tahsilat</h1>
          <form className="payment-limit-form" onSubmit={handleApproval}>
            <label>
              <span>Bayi</span>
              <select defaultValue="">
                <option value="" disabled>Seciniz</option>
                <option value="dealer-a">Bayi A</option>
                <option value="dealer-b">Bayi B</option>
              </select>
            </label>
            <label>
              <span>Tahsilat Tutari</span>
              <input type="text" placeholder="Tutar" inputMode="decimal" />
            </label>
            <button type="submit">Tahsilati Hazirla</button>
          </form>
          {approvalSent && (
            <p className="payment-local-status" role="status">
              Tahsilat on izlemesi hazirlandi. Su an icin gercek bir islem gonderilmedi.
            </p>
          )}
        </div>
      </section>

      <section className="payment-checkout" aria-label="Odeme ekrani on izlemesi">
        <div className="payment-checkout-grid">
          <div className="payment-form-stack">
            <article className="payment-section-card">
              <button
                className="payment-section-header"
                type="button"
                aria-expanded={openSections.card}
                onClick={() => toggleSection('card')}
              >
                <span className="payment-section-title">
                  <span className="payment-section-icon" />
                  Kart Bilgileri
                </span>
                <span className="payment-collapse-icon">{openSections.card ? '^' : 'v'}</span>
              </button>
              {openSections.card && (
                <div className="payment-card-fields">
                  <label className="payment-field payment-wide-field">
                    <span>Ad Soyad</span>
                    <input
                      type="text"
                      value={cardInfo.name}
                      onChange={(event) => updateCardInfo('name', event.target.value)}
                    />
                  </label>
                  <label className="payment-field payment-wide-field">
                    <span>Kart Numarasi</span>
                    <input
                      type="text"
                      value={cardInfo.number}
                      inputMode="numeric"
                      maxLength="19"
                      onChange={(event) => updateCardInfo('number', event.target.value)}
                    />
                  </label>
                  <div className="payment-field-row">
                    <label className="payment-field">
                      <span>Ay / Yil</span>
                      <input
                        type="text"
                        value={cardInfo.expiry}
                        maxLength="5"
                        onChange={(event) => updateCardInfo('expiry', event.target.value)}
                      />
                    </label>
                    <label className="payment-field">
                      <span>CVV2</span>
                      <input
                        type="password"
                        value={cardInfo.cvv}
                        maxLength="4"
                        inputMode="numeric"
                        onFocus={() => setIsCvvFocused(true)}
                        onBlur={() => setIsCvvFocused(false)}
                        onChange={(event) => updateCardInfo('cvv', event.target.value.replace(/\D/g, '').slice(0, 4))}
                      />
                    </label>
                  </div>
                </div>
              )}
            </article>

            <article className="payment-section-card">
              <button
                className="payment-section-header"
                type="button"
                aria-expanded={openSections.options}
                onClick={() => toggleSection('options')}
              >
                <span className="payment-section-title">
                  <span className="payment-section-icon" />
                  Odeme Secenekleri
                </span>
                <span className="payment-collapse-icon">{openSections.options ? '^' : 'v'}</span>
              </button>
              {openSections.options && (
                <div className="payment-options" role="radiogroup" aria-label="Taksit secenekleri">
                  {installmentPlans.map(plan => {
                    const isSelected = plan.count === selectedInstallment;
                    const perInstallment = plan.total / plan.count;

                    return (
                      <button
                        className={`payment-installment-card${isSelected ? ' selected' : ''}`}
                        type="button"
                        role="radio"
                        aria-checked={isSelected}
                        key={plan.count}
                        onClick={() => setSelectedInstallment(plan.count)}
                      >
                        <strong>{plan.label}</strong>
                        <span>{formatTry(perInstallment)} TL / Taksit</span>
                        <b>{formatTry(plan.total)} TL</b>
                      </button>
                    );
                  })}
                </div>
              )}
            </article>

            <article className="payment-section-card">
              <button
                className="payment-section-header"
                type="button"
                aria-expanded={openSections.product}
                onClick={() => toggleSection('product')}
              >
                <span className="payment-section-title">
                  <span className="payment-section-icon" />
                  Tahsilat Bilgileri
                </span>
                <span className="payment-collapse-icon">{openSections.product ? '^' : 'v'}</span>
              </button>
              {openSections.product && (
                <div className="payment-product-info">
                  <div>
                    <span>Islem</span>
                    <strong>Kredi karti tahsilat hizmeti</strong>
                  </div>
                  <div>
                    <span>Tutar</span>
                    <strong>100,00 TL</strong>
                  </div>
                </div>
              )}
            </article>
          </div>

          <aside className="payment-summary-card" aria-label="Siparis ozeti">
            <div className="payment-summary-header">
              <h2>Tahsilat Ozeti</h2>
              <div>
                <span>GENEL TOPLAM</span>
                <strong>{totalText}</strong>
              </div>
            </div>

            <div className={`payment-card-preview${isCvvFocused ? ' flipped' : ''}`} aria-hidden="true">
              <div className="payment-card-inner">
                <div className="payment-card-face payment-card-front">
                  <div className="payment-card-top">
                    <span className="payment-card-rings">oo</span>
                    <span>Guvenli Odeme</span>
                  </div>
                  <div className="payment-chip" />
                  <div className={`payment-card-number${cardNumberClass}`}>
                    {cardInfo.number || '0000 0000 0000 0000'}
                  </div>
                  <div className="payment-card-bottom">
                    <span>{cardInfo.name || 'AD SOYAD'}</span>
                    <span>{cardInfo.expiry || 'AA/YY'}</span>
                  </div>
                </div>
                <div className="payment-card-face payment-card-back">
                  <div className="payment-card-strip" />
                  <div className="payment-card-cvv-row">
                    <span>CVV2</span>
                    <strong>{maskCvv(cardInfo.cvv)}</strong>
                  </div>
                </div>
              </div>
            </div>

            <label className="payment-terms">
              <input type="checkbox" defaultChecked />
              <span>Sozlesme kosullarini okudum ve kabul ediyorum.</span>
            </label>

            <div className="payment-selected-plan">
              <span>{selectedPlan.label}</span>
              <strong>{selectedPlan.count === 1 ? totalText : `${selectedPlan.count} x ${installmentText}`}</strong>
            </div>

            <button className="payment-pay-button" type="button">{totalText} Tahsil Et</button>
            <button className="payment-cancel-button" type="button">Vazgec</button>
          </aside>
        </div>
      </section>
    </div>
  );
}
